const RightArrowIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='10'
		viewBox='0 0 12 12'
		width='10'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9.125 6.75H0V5.25H9.125L4.9375 1.0625L6 0L12 6L6 12L4.9375 10.9375L9.125 6.75Z'
			fill='currentColor'
		/>
	</svg>
)

export { RightArrowIcon }
